import { Component, OnInit, Input, Inject, ElementRef, ViewChild} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FormBuilder } from '@angular/forms';
import { GlobalService } from '../service/global.service';
import { environment } from 'src/environments/environment';
import { ProjectSummaryInfo } from '../model/ProjectSummaryInfo';
import { ActivatedRoute } from '@angular/router';
import { Chart, ChartType, ChartOptions } from 'chart.js';
import { Label, SingleDataSet } from 'ng2-charts';


import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { FormControl } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { TokenService } from '../service/token.service';

@Component({
  selector: 'app-dashboard-detail',
  templateUrl: './dashboard-detail.component.html',
  styleUrls: ['./dashboard-detail.component.css']
})
export class DashboardDetailComponent implements OnInit {

  /******************************* Variables ********************************/
  _EmpCode: string;
  _ProjectCode: string;
  _ProjectName: string;

  baseurl: string;

  ProjectSummary: ProjectSummaryInfo;

  //Pie chart
  public pieChartLabels: Label[] = [];
  public pieChartData: SingleDataSet = [];
  public pieChartType: ChartType = 'pie';
  public pieChartLegend = false;
  public pieChartPlugins = [];
  public pieChartColors = [
    {
      backgroundColor: [],
    },
  ];
  public pieChartOptions: ChartOptions = {
    responsive: true,
    legend: {
      position: 'top'
    }
  };

  @ViewChild('tomailInput') tomailInput: ElementRef<HTMLInputElement>;
  @ViewChild('ccmailInput') ccmailInput: ElementRef<HTMLInputElement>;
  ListEmpEmails: string[] = [];

  //To Mail chips params
  titleMail: string;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  tomailCtrl = new FormControl();
  tomails: string[] = [];
  filteredToMails: Observable<string[]>

  //CC Mail chips params
  ccmail_separatorKeysCodes: number[] = [ENTER, COMMA];
  ccmailCtrl = new FormControl();
  ccmails: string[] = [];
  filteredCCmails: Observable<string[]>
  /******************************* Variables ********************************/

  /******************************* Functions ********************************/
  

  constructor(private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string, private formBuilder: FormBuilder, private GlobalService: GlobalService, private router: ActivatedRoute, private TokenService: TokenService) {
    this.baseurl = environment.base_api;

    this.filteredToMails = this.tomailCtrl.valueChanges.pipe(
      startWith(null),
      map((fruit: string | null) => (fruit ? this._filter(fruit) : this.ListEmpEmails.slice())),
    );

    this.filteredCCmails = this.ccmailCtrl.valueChanges.pipe(
      startWith(null),
      map((name: string | null) => (name ? this._filter(name) : this.ListEmpEmails.slice())),
    );
    //GlobalService.CheckPagingAccessRights();
  }

  async ngOnInit() {
    //Set param
    this.router.params.subscribe(params => {
      this._ProjectCode = params['ProjectCode'];
      this._ProjectName = params['ProjectName'];
    });

    //Initial Data
    
    await this.LoadListProjectSummary();
    await this.LoadListEmpEmails();
  }


  async LoadListProjectSummary() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson["ProjectCode"] = this._ProjectCode;

      let strjson = JSON.stringify(objectjson);

      this.httpClient
        .post<ProjectSummaryInfo>(this.baseurl + "Project/GetProjectSummaryDetail",
          strjson, httpOptions)
        .toPromise().then(data => {
          this.ProjectSummary = data;
          console.log(data);

          var listName = [], listValue = [];
          if (data.ProjectIssuesOwner.length > 0) {

            for (var i in data.ProjectIssuesOwner) {
              listName.push(data.ProjectIssuesOwner[i].OwnerName)
              listValue.push(data.ProjectIssuesOwner[i].SumIssues)
            }

          } else {
            listName = ['-', '-', '-'];
            listValue = [0, 0, 0];
          }


          //Pie chart issue owner
          this.pieChartLabels = listName
          this.pieChartData = listValue;
          this.pieChartColors[0].backgroundColor = ['#01796F', '#48BF91', '#8FD9A8'];
        });
    }
  }

  async LoadListEmpEmails() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};

      let strjson = JSON.stringify(objectjson);

      this.httpClient
        .post<any[]>(this.baseurl + "Employee/GetEmployeeCriteria",
          strjson, httpOptions)
        .toPromise().then(data => {
          if (data.length > 0) {
            var tempArr = [];
            $.each(data, function () {

              if (!!this.Mail) {
                tempArr.push(this.Mail);
              }
            });

            this.ListEmpEmails = tempArr;
            console.log(this.ListEmpEmails);
          }
        });
    }
  }

  OnBtnSendMailClick() {
    $('#modalSendDashboardEmail').modal();
  }

  async OnBtnConfirmSendMailClick() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
    const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson["ProjectCode"] = this._ProjectCode;
      objectjson["ProjectName"] = this._ProjectName;
      objectjson["EmailsTo"] = this.tomails;
      objectjson["EmailsCC"] = this.ccmails;
      objectjson["EmailTitle"] = this.titleMail;

      let strjson = JSON.stringify(objectjson);

      this.httpClient
        .post<any[]>(this.baseurl + "Project/SendMailProjectSummary",
          strjson, httpOptions)
        .toPromise().then(data => {

          var result = true;
          $.each(data, function (i) {
            if (data[i].result_code != '200') {
              result = false;
            }
          });

          if (result) {
            $('#modalSendDashboardEmail').modal('hide');
          }

        });
    }
  }

  add(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();

    // Add our fruit
    if (value) {
      this.tomails.push(value);
    }

    // Clear the input value
    //event.chipInput!.clear();

    this.tomailCtrl.setValue(null);
  }
  add_ccmail(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();

    // Add our fruit
    if (value) {
      this.ccmails.push(value);
    }

    this.ccmailCtrl.setValue(null);
  }

  remove(fruit: string): void {
    const index = this.tomails.indexOf(fruit);

    if (index >= 0) {
      this.tomails.splice(index, 1);
    }
  }
  remove_ccmail(mail: string): void {
    const index = this.ccmails.indexOf(mail);

    if (index >= 0) {
      this.ccmails.splice(index, 1);
    }
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    
    this.tomails.push(event.option.viewValue);
    this.tomailInput.nativeElement.value = '';
    this.tomailCtrl.setValue(null);
  }
  selected_ccmail(event: MatAutocompleteSelectedEvent): void {
    
    this.ccmails.push(event.option.viewValue);
    this.ccmailInput.nativeElement.value = '';
    this.ccmailCtrl.setValue(null);
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.ListEmpEmails.filter(m => m.toLowerCase().includes(filterValue));
  }
  /******************************* Functions ********************************/
}
